import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=a34ec2c8&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=a34ec2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34ec2c8",
  null
  
)

export default component.exports